import React from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
import ErrorText from './ErrorText';
import Input, { InputProps } from './Input';

export type InputFieldProps = InputProps;

export default function InputField(props: InputFieldProps) {
  const { register, formState } = useFormContext();

  const nameOrId = props.name || props.id;
  const error = formState.errors?.[nameOrId] as FieldError;
  return (
    <div>
      <Input {...register(nameOrId)} {...props} />
      {error?.message && <ErrorText className="mt-2" message={error.message} />}
    </div>
  );
}
